export default __webpack_public_path__ + "static/media/podcast-2.8c6607ff.jpg";